import { EventDispatcher } from "strongly-typed-events";
import { PaginationManager } from "../../Common/PaginationManager";
import { DataWarehouseDataService } from "../../../DataService/DataWarehouseDataService";

export class SearchCatalogManager {

    constructor(private containerElement: JQuery) { }

    private selectArticleButton : JQuery<HTMLElement>;

    private searchTimeout : any = null;
    private searchCodeOrDescriptionInput : JQuery<HTMLElement>;
    private searchCatalogSelect : JQuery<HTMLElement>;
    private clearFiltersButton : JQuery<HTMLElement>;

    private articlesTable : JQuery<HTMLElement>;
    private articlesTableBody : JQuery<HTMLElement>;

    private paginationContainer: JQuery<HTMLElement>;
    private paginationManager: PaginationManager;

    public articleSelectedEvent = new EventDispatcher<SearchCatalogManager, {catalog: string, articleCode: string, articleDescription: string} >();

    private docDetailId : any;


    public initialize(docDetailId: any) {
        var self = this;
        self.docDetailId = docDetailId;

        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.selectArticleButton = self.containerElement.find('[data-action="select-catalog-article"]');

        self.searchCodeOrDescriptionInput = self.containerElement.find('#search-by-code-or-description-filter');
        self.searchCatalogSelect = self.containerElement.find('#search-by-catalog-select');
        self.clearFiltersButton = self.containerElement.find('button[data-action="clear-catalog-search-filters"]');
    
        self.articlesTable = this.containerElement.find('#articles-table');
        self.articlesTableBody = self.articlesTable.find('#catalog-search-results');

        self.paginationContainer = self.containerElement.find('.search-catalog-navigation');
        self.paginationManager = new PaginationManager(self.paginationContainer, 100, false)
    }

    private bindEvents() {
        var self = this;

        self.updatePagination();
        self.bindArticleTableContainer();

        self.paginationManager.pageChanged.subscribe(() => {
            self.loadArticles();
        });


        self.selectArticleButton.off('click').on('click', () => {
            var selectedTableRow = self.articlesTableBody.find('tr.is-selected');
            if(selectedTableRow == undefined || selectedTableRow.length == 0) {
                return;
            }

            self.selectArticleButton.prop('disabled', true);
            var selectedArticleId = selectedTableRow.data('article-id');

            DataWarehouseDataService.addDocDetailSuggestionAndSelect(this.docDetailId, selectedArticleId, () => {
                var catalog = selectedTableRow.find('td[data-field="article-catalog"]').text();
                var code = selectedTableRow.find('td[data-field="article-code"]').text();
                var description = selectedTableRow.find('td[data-field="article-description"]').text();

                self.articleSelectedEvent.dispatch(this, {catalog: catalog, articleCode: code, articleDescription: description});
            })
        })

        self.containerElement.find("input[type='text']").on("keyup", () => { self.delayedSearch() });
        self.containerElement.find("select").on("change", () => { self.delayedSearch(); });
        self.clearFiltersButton.off('click').on('click', () => {

            self.containerElement.find("input[type='text']").val('');
            self.searchCatalogSelect.val('');
            self.loadArticles();

        })

    }

    private delayedSearch() {

        var self = this;

        if (self.searchTimeout) {
            clearTimeout(self.searchTimeout);
        }

        self.searchTimeout = setTimeout(() => { self.loadArticles(); }, 500);
    }

    private loadArticles() {
        var self = this;

        self.selectArticleButton.prop('disabled', true);

        //TODO: Add filters;

        self.articlesTableBody.load('?handler=SearchSuggestionInCatalog',
        {
            "CurrentPage" : this.paginationManager.currentPage,
            "PageSize" : this.paginationManager.pageSize,
            "CodeOrDescription": self.searchCodeOrDescriptionInput.val(),
            "Catalog": self.searchCatalogSelect.val(),

            //"__RequestVerificationToken": (window as any).getToken()
        }, () => {

            this.updatePagination();
            self.bindArticleTableContainer();
        });
    }

    private updatePagination()
    {
        var self = this;

        var firstLine = self.articlesTableBody.children().first();

        var totalNumberOfItems = firstLine.data('total-number-of-items');

        var currentPage = firstLine.data('current-page');

        var amountOfPages = Math.ceil(Number(totalNumberOfItems / self.paginationManager.pageSize));

        self.paginationManager.setPagination(currentPage, self.paginationManager.pageSize, amountOfPages, totalNumberOfItems);
    }


    private bindArticleTableContainer() {
        var self = this;

        const container = self.articlesTableBody;

        container.on('click', 'tr[data-article-id]', function (event) {
            event.preventDefault();

            const row = $(this);
            const radio = row.find('.catalog-search-radio') as JQuery<HTMLInputElement>;

            const isSelected = row.hasClass('is-selected');

            container.find('tr[data-article-id]').removeClass('is-selected');

            container.find('.catalog-search-radio').prop('checked', false);

            if (isSelected) {
                self.selectArticleButton.prop('disabled', true);

                return;
            }

            row.addClass('is-selected');

            radio.prop('checked', true);

            self.selectArticleButton.prop('disabled', false);
        });
    }
}